import "../../styles/ReusableStyles/FooterOverlay.css";

const FooterOverlay = () => {
  const totalLines = 13; // Total lines to be rendered
  const lineSpacing = 8; // Spacing between lines in pixels
  const fadeStartIndex = 6; // Start fading from this line number
  const startY = 60; // Starting Y position in pixels

  return (
    <>
      {/* Desktop Overlay */}
      <svg className="footer-dashed-lines desktop" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        {[...Array(totalLines)].map((_, index) => {
          let opacity = 0.38;
          if (index >= fadeStartIndex) {
            const remainingLines = totalLines - fadeStartIndex;
            const currentPosition = index - fadeStartIndex;
            opacity = Math.max(0.38 - ((currentPosition / remainingLines) * 0.38), 0);
          }
          const yPosition = startY + (index * lineSpacing);
          return (
            <line key={`desktop-${index}`} x1="0" y1={yPosition} x2="100%" y2={yPosition} stroke={`rgba(255, 255, 255, ${opacity})`} strokeWidth="1" strokeDasharray="2, 2" />
          );
        })}
      </svg>

      {/* Mobile Overlay */}
      <svg className="footer-dashed-lines mobile" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        {[...Array(totalLines)].map((_, index) => {
          let opacity = 0.38;
          if (index >= fadeStartIndex) {
            const remainingLines = totalLines - fadeStartIndex;
            const currentPosition = index - fadeStartIndex;
            opacity = Math.max(0.38 - ((currentPosition / remainingLines) * 0.38), 0);
          }
          const yPosition = 20 + (index * 8);
          return (
            <line key={`mobile-${index}`} x1="0" y1={yPosition} x2="100%" y2={yPosition} stroke={`rgba(255, 255, 255, ${opacity})`} strokeWidth="1" strokeDasharray="2, 2" />
          );
        })}
      </svg>
    </>
  );
};

export default FooterOverlay;
